import styles from './list.module.css';
import { Breadcrumbs, Link, Typography } from '@mui/material';
import { TextField, Button, Tooltip } from '@mui/material';
import DataTable from 'react-data-table-component';
import { Plus, X, Edit, Trash2, ChevronDown } from 'react-feather';
import axios from 'axios';
import Modal from 'react-bootstrap/Modal';
import { TableLoader } from '../../components/LoaderC';
import Loader from '../../components/Loader';
import { authData } from "../../components/getAuth";
import ProductAddForm from "./addForm";
import Dropdown from 'react-bootstrap/Dropdown';
import withAdminAuth from "../../components/withAdminAuth";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useState } from 'react';
import { useEffect } from 'react';

const customDataTableStyles = {
  head: {
    style: {
      zIndex: 0
    },
  },
  headCells: {
    style: {
      backgroundColor: '#1e1e2d',
      color: '#fff'
    },
  },
}

const ProductList = ({ history, match }) => {
  const auth = authData();
  const [loading, setLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(true);
  const [allData, setAllData] = useState([]);
  const [data, setData] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [addModalShow, setAddModalShow] = useState(false);
  const [editModalShow, setEditModalShow] = useState(false);
  const [filterText, setFilterText] = useState('');
  const [currentItem, setCurrentItem] = useState(0);

  const columns = [{
    name: 'Title',
    selector: row => row.title,
    sortable: true,
  }, {
    name: 'Category',
    selector: row => row.parent ? row.parent?.title : '-',
    sortable: true,
  }, {
    name: 'Amount',
    cell: tableProps => (tableProps.parent || tableProps.no_of_child === 0) ? <>&pound; {parseFloat(tableProps.amount).toFixed(2)}</> : '-',
    sortable: true,
    sortFunction: (rowA, rowB) => {
      const a = rowA.amount;
      const b = rowB.amount;

      if (a > b) {
        return 1;
      }

      if (b > a) {
        return -1;
      }

      return 0;
    }
  }, {
    name: 'Status',
    cell: tableProps => ((tableProps.status === 1 || tableProps.status === "1") ? <Dropdown className="StatusDropDown">
      <Dropdown.Toggle className={`${styles.ActiveBU}`} id={"dropdown-basic" + tableProps.id} size="sm">Active <ChevronDown /></Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item onClick={(e) => statusChange(tableProps.id, 0)}>Archived</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown> : <Dropdown className="StatusDropDown">
      <Dropdown.Toggle className={`${styles.ArchiveBU}`} id={"dropdown-basic" + tableProps.id} size="sm">Archived <ChevronDown /></Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item onClick={(e) => statusChange(tableProps.id, 1)}>Active</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>),
    sortable: false,
  }, {
    name: 'Action',
    cell: tableProps => (
      <div className={`${styles.ActionDiv}`}>
        <Tooltip title="Edit"><Button onClick={(e) => { setEditModalShow(true); setCurrentItem(tableProps.id); }}><Edit /></Button></Tooltip>
        <Tooltip title="Delete"><Button onClick={(e) => { setModalShow(true); setCurrentItem(tableProps.id); }}><Trash2 /></Button></Tooltip>
      </div>),
    sortable: false,
  }];

  useEffect(() => {
    const fetchUsers = () => {
      axios(process.env.REACT_APP_API_URL + 'v1/delivery-products', {
        headers: {
          Authorization: `Bearer ${auth?.api_token}`,
        }
      }).then(response => {
        setContentLoading(false);
        if (response.data.status === 'SUCCESS') {
          setAllData(response.data.data);
        }
      }).catch(error => {
        setContentLoading(false);
      });
    }

    fetchUsers();
  }, [auth?.api_token]);

  useEffect(() => {
    let filteredData = allData;

    if (filterText !== '') {
      let inputVal = filterText;
      filteredData = filteredData.filter((item) => {
        return item?.title.toLowerCase().includes(inputVal) || item?.parent?.title.toLowerCase().includes(inputVal) || item?.amount === parseInt(inputVal);

      });
    }

    setData(filteredData);
  }, [allData, filterText]);

  const statusChange = (id, status) => {
    setLoading(true);
    axios.post(process.env.REACT_APP_API_URL + 'v1/update-delivery-products/' + id, { status: status }, {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      }
    }).then(response => {
      setLoading(false);
      if (response.data.status === 'SUCCESS') {
        toast.success(response.data.message, {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          theme: "light",
        });

        setAllData(prev => {
          return prev.map(i => {
            if (i.id === id)
              return { ...i, status: status }
            return i;
          });
        })
      }
    }).catch(error => {
      setLoading(false);
    });
  }

  const deleteConfirm = () => {
    setLoading(true);
    setModalShow(false);
    axios.delete(process.env.REACT_APP_API_URL + 'v1/delivery-products/' + currentItem, {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      }
    }).then(response => {
      setLoading(false);
      if (response.data.status === 'SUCCESS') {
        toast.success(response.data.message, {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          theme: "light",
        });

        setAllData(prev => {
          return prev.filter(i => i.id !== currentItem);
        })

        setCurrentItem(0);
      }
    }).catch(error => {
      setLoading(false);
    });
  }

  const onSubmitAddForm = () => {
    axios(process.env.REACT_APP_API_URL + 'v1/delivery-products', {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      }
    }).then(response => {
      if (response.data.status === 'SUCCESS') {
        setAllData(response.data.data);
      }
    }).catch(error => { })
  }

  return (<>
    {loading && <Loader />}
    {contentLoading && <div className="LoaderCard"><div className="Loader TableLoader"><TableLoader /></div></div>}
    {!contentLoading && <div className={`${styles.MainDiv}`}>
      <div className={`${styles.PageTitleWrap}`}>
        <p className={`${styles.PageTitle}`}>Delivery Item List</p>
        <Breadcrumbs aria-label="breadcrumb" className='breadcrumb'>
          <Typography color="text.primary">Delivery Item</Typography>
          <Typography color="text.primary">List</Typography>
        </Breadcrumbs>
      </div>
      <div className={`${styles.MainCard}`}>
        <div className='TableFilterHead'>
          <div className="DataTableSearch">
            <TextField id="search" type="text" placeholder="Search" aria-label="Search Input" value={filterText} onChange={(e) => setFilterText(e.target.value)} />
            {filterText !== '' && <Button type="button" className="CloseBU" onClick={(e) => setFilterText('')}><X /></Button>}
          </div>
          <div className='TableFilterBUSec'>
            <Link onClick={(e) => setAddModalShow(true)} className="TableAddBU"><Plus /> Item</Link>
          </div >
        </div >

        <div className='TableContent'>
          <DataTable className='DataTable'
            columns={columns}
            data={data}
            pagination
            customStyles={customDataTableStyles}
          />
        </div>
      </div >
    </div >}

    <Modal show={modalShow} onHide={(e) => { setModalShow(false); setCurrentItem(0); }} centered className='CusModal'>
      <Modal.Header closeButton>
        <Modal.Title>Delete Item</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className='Message'>Are you sure you want to delete this item?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button className='PopUpCanBU' onClick={(e) => { setModalShow(false); setCurrentItem(0); }}>Cancel</Button>
        <Button className='PopUpSubmitBU' onClick={(e) => deleteConfirm()}>Confirm Delete</Button>
      </Modal.Footer>
    </Modal>

    <Modal show={addModalShow} onHide={(e) => { setAddModalShow(false); setCurrentItem(0); }} centered className='CusModal'>
      <Modal.Header closeButton>
        <Modal.Title>Add Item</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ProductAddForm onSubmit={onSubmitAddForm.bind(this)} isAddMode={true} id={currentItem} setModalShow={setAddModalShow.bind(this)} setCurrentItem={setCurrentItem.bind(this)} setLoading={setLoading.bind(this)} />
      </Modal.Body>
    </Modal>

    <Modal show={editModalShow} onHide={(e) => { setEditModalShow(false); setCurrentItem(0); }} centered className='CusModal'>
      <Modal.Header closeButton>
        <Modal.Title>Edit Item</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ProductAddForm onSubmit={onSubmitAddForm.bind(this)} isAddMode={false} id={currentItem} setModalShow={setEditModalShow.bind(this)} setCurrentItem={setCurrentItem.bind(this)} setLoading={setLoading.bind(this)} />
      </Modal.Body>
    </Modal>
  </>
  )
}

export default withAdminAuth(ProductList);